module.exports = __webpack_public_path__ + "img/JanikGasiorowski.3197a5f5.jpg";